/* Muni Vibes — the small amount of JS this site earns.
   No carousels, no popups, no countdowns. Progressive: everything below
   works without it, this just removes friction. */

(function () {
  "use strict";

  /* Nav dropdowns. The <details> elements open and close on their own, and
     the site is usable if this whole file never loads. All this adds is the
     three courtesies a menu is expected to have: Escape closes it, clicking
     away closes it, and opening one closes its siblings.

     Anything on the same branch as the one being opened is left alone, in
     both directions. Ancestors are obvious: closing them would take the
     maker flyout's own panel down with it. Descendants matter because
     `toggle` fires asynchronously, so two clicks landing in the same tick
     arrive as two queued events, and the earlier one would otherwise close
     a menu the later one had legitimately just opened. */
  var drops = [].slice.call(document.querySelectorAll("[data-drop]"));
  if (drops.length) {
    var shut = function (keep) {
      drops.forEach(function (d) {
        if (d === keep) return;
        if (keep && (d.contains(keep) || keep.contains(d))) return;
        d.open = false;
      });
    };

    drops.forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (d.open) shut(d);
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest || !e.target.closest("[data-drop]")) shut(null);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") shut(null);
    });
  }

  /* Product gallery. The strip scrolls and snaps on its own; this only
     keeps the thumbnails in sync with where you actually are. Nothing
     auto-advances — it's the customer's scroll, not ours. */
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var strip = gallery.querySelector("[data-gallery-strip]");
    var thumbs = [].slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));

    if (strip && thumbs.length) {
      var shots = [].slice.call(strip.children);

      var mark = function (i) {
        thumbs.forEach(function (t, n) {
          t.classList.toggle("is-on", n === i);
        });
      };

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener("click", function (e) {
          e.preventDefault();
          /* scrollIntoView would also scroll the page vertically on some
             browsers; setting scrollLeft keeps it to the strip. */
          strip.scrollTo({ left: shots[i].offsetLeft - shots[0].offsetLeft,
                           behavior: "smooth" });
          mark(i);
        });
      });

      if ("IntersectionObserver" in window) {
        var seen = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) mark(shots.indexOf(entry.target));
          });
        }, { root: strip, threshold: 0.6 });
        shots.forEach(function (shot) { seen.observe(shot); });
      }
    }
  }

  /* Quantity steppers submit the cart form on change so there's no
     hunting for an Update button. */
  document.querySelectorAll("[data-cart-qty]").forEach(function (input) {
    input.addEventListener("change", function () {
      var form = input.closest("form");
      if (form) form.submit();
    });
  });

  /* Product variant picker: keep the URL and the buy button honest about
     which variant is actually selected. */
  var picker = document.querySelector("[data-variants]");
  if (picker) {
    var form = picker.closest("form");
    var idField = form && form.querySelector('[name="id"]');
    var priceEl = document.querySelector("[data-price]");
    var submit = form && form.querySelector('[type="submit"]');
    var variants = [];
    try {
      variants = JSON.parse(picker.getAttribute("data-variants")) || [];
    } catch (e) {
      variants = [];
    }

    picker.addEventListener("change", function () {
      var id = picker.value;
      var v = variants.filter(function (x) {
        return String(x.id) === String(id);
      })[0];
      if (!v) return;

      if (idField) idField.value = v.id;
      if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;

      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available
          ? submit.getAttribute("data-label-add")
          : submit.getAttribute("data-label-sold");
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url.toString());
      }
    });
  }
})();
